var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "form",
      {
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.SEND()
          },
        },
      },
      [
        _c("div", { staticClass: "form-group mb-3" }, [
          _c("small", { staticClass: "input-title" }, [
            _vm._v("Dirección de correo electrónico"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-group" },
            [
              _vm._m(1),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.email,
                    expression: "data.email",
                  },
                ],
                staticClass: "form-control",
                class: _vm.errors.email ? "is-invalid" : "",
                attrs: { type: "email", name: "email" },
                domProps: { value: _vm.data.email },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.data, "email", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _vm._l(_vm.errors.email, function (error, index) {
                return _c(
                  "small",
                  { key: index, staticClass: "invalid-feedback" },
                  [_vm._v(_vm._s(error))]
                )
              }),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group mb-3" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-x w-100",
              attrs: { type: "submit" },
            },
            [
              _vm.count == 1
                ? _c(
                    "div",
                    {
                      staticClass: "spinner-border spinner-border-sm",
                      attrs: { role: "status" },
                    },
                    [
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("Loading..."),
                      ]),
                    ]
                  )
                : _c("span", [_vm._v("Has olvidado tu contraseña")]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-dark btn-x w-100",
                attrs: { to: { name: "Login" } },
              },
              [_c("span", [_vm._v("Atrás para iniciar sesión")])]
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-4 mb-5 text-left" }, [
      _c("p", { staticClass: "text-lg mb-1" }, [
        _vm._v("¿Olvidaste tu contraseña?"),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "text-sm text-muted" }, [
        _vm._v(
          "Ingrese la dirección de correo electrónico\n            asociada con su cuenta y le enviaremos un enlace por correo electrónico para\n            restablecer su contraseña.\n        "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "bi bi-envelope" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }